import React from 'react';
import { useTranslation } from 'react-i18next';
import { MatchMakerAnswers } from '../../../../../shared/types';
import { TrackableComponent, FieldError, NumericInput } from '../../../../components';
import { ErrorMessage } from 'formik';

interface InputProps {
  values: MatchMakerAnswers;
}

export const MonthlyBudgetInput: React.FC<InputProps> = ({ values }) => {
  const { t } = useTranslation('match-maker');
  return (
    <div className="u-mt-large">
      <TrackableComponent
        trackingComponent="CustomRangeSlider"
        trackingFunction={`sliderLabelMonthlyPayment${values.expectedMonthlyPayment}`}
      >
        <NumericInput
          fieldName="expectedMonthlyPayment"
          placeholder={t('question-pages.items.installments.input-field.placeholder')}
          addonText={t('question-pages.items.installments.input-field.addon')}
        />
      </TrackableComponent>
      <ErrorMessage name="expectedMonthlyPayment">
        {(msg) => <FieldError id="expectedMonthlyPayment" errorMessage={msg} />}
      </ErrorMessage>
    </div>
  );
};
